import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import Loader from "./Loader";
import {
  getPasswordHelper,
  isPasswordSecure,
  PASSWORD_VALIDATION_ERROR,
} from "../utils/passwordSecurity";

const RecoverPasswordForm = ({
  saveRecoverPasswordForm,
  token,
  isUserLoading,
  disableUserLoader,
}) => {
  const [passwordIsFocused, setPasswordIsFocused] = useState(false);

  useEffect(() => {
    return () => {
      disableUserLoader();
    };
  }, [disableUserLoader]); //eslint-disable-line

  return (
    <>
      <Loader isActive={isUserLoading} />
      <div className="card">
        <div className="card-content">
          <div className="card-body">
            <Formik
              enableReinitialize
              initialValues={{
                token: token,
                password: "",
                passwordConfirmation: "",
              }}
              onSubmit={(values, { setSubmitting }) => {
                setTimeout(() => {
                  setSubmitting(false);
                  saveRecoverPasswordForm(values);
                }, 500);
              }}
              validationSchema={Yup.object().shape({
                password: Yup.string()
                  .required("Champ Requis")
                  .test(
                    "password-security-requirements",
                    PASSWORD_VALIDATION_ERROR,
                    (value) => !value || isPasswordSecure(value),
                  ),
                passwordConfirmation: Yup.string()
                  .required("Champ Requis")
                  .oneOf(
                    [Yup.ref("password"), null],
                    "Les mots de passes doivent être identiques",
                  ),
              })}
            >
              {(props) => {
                const {
                  values,
                  touched,
                  errors,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                } = props;

                const passwordHelper = getPasswordHelper(values.password);

                return (
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-12">
                        <div className="form-group has-danger">
                          <div>
                            <label htmlFor="password">Mot de passe</label>
                            <input
                              type="password"
                              id="password"
                              placeholder="Mot de passe"
                              className="form-control"
                              onChange={handleChange}
                              onBlur={(event) => {
                                handleBlur(event);
                                setPasswordIsFocused(false);
                              }}
                              onFocus={() => setPasswordIsFocused(true)}
                              value={values.password}
                            />
                            {passwordIsFocused && (
                              <div className={passwordHelper.className}>
                                {passwordHelper.message}
                              </div>
                            )}
                            {errors.password &&
                              touched.password &&
                              (!passwordIsFocused ||
                                errors.password !==
                                  PASSWORD_VALIDATION_ERROR) && (
                                <div className="mt-1 danger">
                                  {errors.password}
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="form-group has-danger">
                          <div>
                            <label htmlFor="passwordConfirmation">
                              Confirmer le mot de passe
                            </label>
                            <input
                              type="password"
                              id="passwordConfirmation"
                              placeholder="Confirmer le mot de passe"
                              className="form-control"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.passwordConfirmation}
                            />
                            {errors.passwordConfirmation &&
                              touched.passwordConfirmation && (
                                <div className="mt-1 danger">
                                  {errors.passwordConfirmation}
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                      <div className="col-12 d-flex flex-sm-row flex-column justify-content-end">
                        <button type="submit" className="btn btn-primary ">
                          Enregistrer
                        </button>
                      </div>
                    </div>
                  </form>
                );
              }}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
};

export default RecoverPasswordForm;
